import { MDXAspect } from './mdx.aspect';

export default MDXAspect;
export type { MDXMain } from './mdx.main.runtime';
export { MdxEnv } from './mdx.env';

export { MDXAspect };
